import { useCallback } from "react"
import { useDialog } from "../../libs/dialog/DialogProvider"
import { Button, DialogActions } from "@mui/material"

export function Confirm(props:{message:string,yes:()=>void}) {
    const {closeDialog} = useDialog()
    const onYes = () => {
        closeDialog()
        props.yes()
    }
    return <>
        <div className="content">
            <p>{props.message}</p>
        </div>
        <DialogActions>
            <Button color="primary" onClick={onYes}>Yes</Button>
        </DialogActions>
    </>
}

export default function useConfirm(){
    const {openDialog} = useDialog()

    const confirm = useCallback((msg:string, yes:()=>void) => {
        openDialog({id:"confirm",children:<Confirm message={msg} yes={yes}/>})
    }, [])

    return {confirm}
}